import React, { useState, useEffect, useMemo } from "react";
import { isMarketRestrictedWantAd } from "@/helpers/marketRestriction";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { PageWrapper } from "@/components/PageWrapper";
import WantAdMoreIcon from "@/images/want-ad-more-icon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  getWantAdById,
  deleteWantAd,
  archiveWantAd,
  unArchiveWantAd,
  getMyWantAds,
} from "@/services/v2/wantAdService";
import BedIcon from "@/images/bed-icon.svg";
import BathIcon from "@/images/bath-icon.svg";
import SqftIcon from "@/images/sqft-icon.svg";
import MoneyIcon from "@/images/money-icon.svg";
import {
  getDisplayTextForClientFilledWantAds,
  getLocalStorage,
  getUserId,
  locationDisplayInListing,
  loggedInUser,
  setLocalStorage,
  truncate,
} from "@/helpers/common";
import DeleteModal from "@/components/Common/DeleteModal";
import {
  BUDGET_NOMIN_NOMAX,
  USER_INFO_KEY,
  WANT_AD_KEY,
} from "@/constants/common";
import { toast } from "react-toastify";
import ArchiveModal from "@/components/MyWantAd/ArchiveModal";
import ShareYourAdModal from "@/components/MemberWantAd/v2/ShareYourAdModal";
import { pageURLs } from "@/constants/pageURLs";
import SelectDropDown from "@/components/Common/SelectDropDown";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import {
  getPropertyIcon,
  getCombinedText,
} from "@/helpers/getPropertyIcons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { wantAdBudgetValue, wantAdSqftValue } from "@/helpers/createWantAd";
import { LOT_LAND } from "@/constants/common";
import noImage from "@/images/no-image-placeholder.png";
import CustomLinkModal from "@/components/Common/CustomLinkModal";
import Loader from "@/components/Common/Loader";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import StaticMapboxComponent from "@/components/Common/StaticMapboxComponent";
import usePolygons from "@/hooks/usePolygons";

const parseDrawnPolygon = (drawnPolygonText) => {
  if (!drawnPolygonText) return null;
  const match = drawnPolygonText.match(/POLYGON\(\((.+)\)\)/i);
  if (!match) return null;
  const coords = match[1].split(",").map((pair) => {
    const [lng, lat] = pair.trim().split(/\s+/).map(Number);
    return { lng, lat };
  });
  return [[coords]];
};

const WantAdCard = ({
  wantAd,
  ival,
  status,
  viewIntroductions,
  onEdit,
  onShare,
  agent,
  setLinkToShare,
  handleCustomLinkPopupOpen,
  renderTooltip,
}) => {
  const PropertyTypeId = _.get(wantAd, "PropertyTypeId", "");
  const subPropertyTypeId = _.get(wantAd, "subPropertyTypeId", "");
  const Buy_or_Rent = _.get(wantAd, "Buy_or_Rent", 1);
  const IsFilledByClient = _.get(wantAd, "IsFilledByClient", 0);
  const IsReadyToReview = _.get(wantAd, "IsReadyToReview", 0);
  const sqFt = wantAdSqftValue(wantAd?.Sqft_mn, wantAd?.Sqft_mx);
  const Longitude = _.get(wantAd, "Longitude", null);
  const Latitude = _.get(wantAd, "Latitude", null);
  const Radius = _.get(wantAd, "Radius", null);
  const zipCode = _.get(wantAd, "zipCode", null);
  const DrawnPolygonText = _.get(wantAd, "DrawnPolygonText", "");

  const { polygonCoordinates, isLoadingBoundaries } = usePolygons(
    zipCode,
    false,
  );
  const drawnPolygonCoords = useMemo(() => parseDrawnPolygon(DrawnPolygonText), [DrawnPolygonText]);

  const budget = wantAdBudgetValue(
    _.get(wantAd, "Budget_mn", ""),
    _.get(wantAd, "Budget_mx", ""),
  );

  const hasPolygon =
    !!drawnPolygonCoords ||
    (Array.isArray(polygonCoordinates) &&
      polygonCoordinates.length > 0 &&
      Array.isArray(zipCode) &&
      zipCode.length > 0);

  return (
    <div className="col-md-4  mb-4 mb-md-0">
      <a
        href={void 0}
        role="button"
        className="txt-no-underline click-want-listing"
        onClick={(e) => {
          if (IsFilledByClient && !IsReadyToReview) {
          } else {
            status != "Draft"
              ? viewIntroductions(wantAd?.Want_ad_Id, wantAd?.slug, status)
              : onEdit(wantAd?.Want_ad_Id);
          }
        }}
      >
        <div className="my-wantad-display mb-0">
          <div className="my-wantad-map placeholder-wrap-bg h-164">
            {PropertyTypeId && (
              <div className="modal-property-tile tile-loation">
                <OverlayTrigger
                  placement="bottom-start"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip(
                    PropertyTypeId,
                    subPropertyTypeId,
                    Buy_or_Rent,
                  )}
                >
                  <div className="property-tile w-auto">
                    {
                      subPropertyTypeId &&
                      subPropertyTypeId.length > 0 &&
                      subPropertyTypeId.map((subtype) => {
                        return (
                          <img
                            src={getPropertyIcon(subtype)}
                            alt={getPropertyIcon(subtype)}
                            className="property-icon-img"
                          />
                        );
                      })
                    }
                  </div>
                </OverlayTrigger>
              </div>
            )}

            {Longitude && Latitude ? (
              <StaticMapboxComponent
                padding={60}
                width={233}
                height={164}
                center={[Longitude, Latitude]}
                radiusMiles={drawnPolygonCoords ? null : (hasPolygon ? null : Radius)}
                polygonCoordinates={drawnPolygonCoords || polygonCoordinates}
                showPolygon={hasPolygon}
                pendingPolygon={!drawnPolygonCoords && isLoadingBoundaries}
              />
            ) : (
              <img src={noImage} className="brdr-13 placeholder-img-style" />
            )}
          </div>
          <div className="my-wantad-details">
            <div className="my-wantad-details-top d-flex justify-content-between">
              <div className="long-txt-fix-new">
                <div
                  className={
                    wantAd.Buy_or_Rent != 0
                      ? "want-ad-tag mb-2 grey-tag-bg"
                      : "want-ad-tag mb-2"
                  }
                >
                  <span className="tag-icon grey-color-icon text-capitalize">
                    {wantAd.IsArchived != 1 && wantAd.Buy_or_Rent != 0 && (
                      <svg
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.2375 1.1665C7.14658 1.1665 7.05567 1.19604 6.98044 1.25548L3.04229 4.36637C2.53882 4.76387 2.25 5.36044 2.25 6.00266V11.3054C2.25 11.6884 2.56089 11.9998 2.94271 11.9998H5.71354C6.09536 11.9998 6.40625 11.6884 6.40625 11.3054V8.24984C6.40625 8.17345 6.46832 8.11095 6.54479 8.11095H7.93021C8.00668 8.11095 8.06875 8.17345 8.06875 8.24984V9.71034L8.9 8.87701V8.24984C8.9 7.71373 8.46498 7.27761 7.93021 7.27761H6.54479C6.01002 7.27761 5.575 7.71373 5.575 8.24984V11.1665H3.08125V6.00266C3.08125 5.6171 3.25438 5.25955 3.5564 5.02121L7.2375 2.11323L10.9186 5.02121C11.2206 5.25955 11.3938 5.6171 11.3938 6.00266V6.1665C11.6855 6.1665 11.9645 6.21967 12.225 6.31245V6.00266C12.225 5.36016 11.9362 4.76415 11.4327 4.36637L7.49456 1.25548C7.41919 1.19604 7.32842 1.1665 7.2375 1.1665ZM11.3938 6.72206C10.3225 6.72206 9.45417 7.59261 9.45417 8.6665C9.45417 8.80345 9.46842 8.93692 9.4953 9.06581L7.31868 11.2479C7.26659 11.2998 7.2375 11.3707 7.2375 11.4443V12.5554C7.2375 12.7087 7.36136 12.8332 7.51458 12.8332H8.62292C8.77614 12.8332 8.9 12.7087 8.9 12.5554V11.9998H9.45417C9.60739 11.9998 9.73125 11.8754 9.73125 11.7221V11.1665H10.2854C10.4386 11.1665 10.5625 11.0421 10.5625 10.8887V10.4211C10.8146 10.5413 11.0959 10.6109 11.3938 10.6109C12.465 10.6109 13.3333 9.74039 13.3333 8.6665C13.3333 7.59261 12.465 6.72206 11.3938 6.72206ZM11.6708 7.83317C11.977 7.83317 12.225 8.08178 12.225 8.38873C12.225 8.69567 11.977 8.94428 11.6708 8.94428C11.3647 8.94428 11.1167 8.69567 11.1167 8.38873C11.1167 8.08178 11.3647 7.83317 11.6708 7.83317Z"
                          fill="#15181E"
                        />
                      </svg>
                    )}
                    {wantAd.Buy_or_Rent == 1
                      ? "BUY"
                      : wantAd.Buy_or_Rent == 2
                        ? "RENT"
                        : wantAd.Buy_or_Rent == 3
                          ? "STAY"
                          : ""}
                  </span>
                </div>{" "}
                {wantAd.IsArchived == 1 && (
                  <div className="want-ad-tag mb-2 red-tag-bg">
                    <span className="tag-icon red-color-icon text-capitalize">
                      PAUSED
                    </span>
                  </div>
                )}
                {IsFilledByClient == 1 && status === "Draft" && (
                  <div
                    className={
                      IsReadyToReview
                        ? "want-ad-tag mb-2 grey-tag-bg"
                        : "want-ad-tag mb-2 red-tag-bg"
                    }
                  >
                    <span
                      className={
                        IsReadyToReview
                          ? "tag-icon grey-color-icon text-capitalize"
                          : "tag-icon red-color-icon text-capitalize"
                      }
                    >
                      {getDisplayTextForClientFilledWantAds(
                        IsFilledByClient,
                        IsReadyToReview,
                      )}
                    </span>
                  </div>
                )}
                {status == "Published" && wantAd.IsArchived != 1 && (
                  <div
                    className={
                      wantAd.IntroCount > 0
                        ? "want-ad-tag mb-2 green-tag-bg"
                        : "want-ad-tag mb-2 grey-tag-bg"
                    }
                  >
                    <span className="tag-icon grey-color-icon text-lowercase">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.30278 1.75224C8.00974 1.76581 7.7178 1.84107 7.44544 1.97726C7.43752 1.9812 7.42974 1.98538 7.42208 1.98979L6.59493 2.46773C6.5862 2.46728 6.57746 2.46709 6.56873 2.46716H1.02706C0.969085 2.46635 0.911527 2.47706 0.857728 2.49867C0.803929 2.52029 0.754964 2.55239 0.713677 2.59309C0.67239 2.6338 0.639606 2.68231 0.617229 2.7358C0.594852 2.78928 0.583328 2.84669 0.583328 2.90466C0.583328 2.96264 0.594852 3.02005 0.617229 3.07353C0.639606 3.12702 0.67239 3.17553 0.713677 3.21624C0.754964 3.25694 0.803929 3.28904 0.857728 3.31066C0.911527 3.33227 0.969085 3.34298 1.02706 3.34217H4.7498L4.55953 3.42135C4.55008 3.4252 4.54077 3.42938 4.53162 3.43388C4.04676 3.67631 3.82308 4.19274 3.87138 4.65751C3.91968 5.12229 4.25241 5.58564 4.78569 5.71879C4.99356 5.77059 5.22447 5.80082 5.47612 5.80082C6.75175 5.80082 8.00174 5.40334 8.3717 5.28072C8.61498 5.55233 9.81473 6.89309 10.2157 7.30359C10.5061 7.60071 10.5355 7.89079 10.4607 8.09713C10.3858 8.30347 10.216 8.46286 9.84599 8.46399C9.7455 8.46429 9.64818 8.49916 9.57038 8.56275C9.49257 8.62634 9.43903 8.71478 9.41874 8.81319C9.30966 9.34076 9.11715 9.41564 8.92086 9.46716C8.72456 9.51869 8.5352 9.474 8.5352 9.474C8.4714 9.45658 8.40448 9.45385 8.33947 9.46602C8.27446 9.47818 8.21306 9.50493 8.15987 9.54424C8.10669 9.58355 8.06311 9.63441 8.03241 9.69299C8.00171 9.75157 7.98469 9.81634 7.98263 9.88245C7.98263 9.88245 7.9681 10.1083 7.85673 10.3017C7.74536 10.4951 7.62938 10.6581 7.1099 10.6014C6.99965 10.5892 6.88891 10.6194 6.80008 10.6858C6.71125 10.7523 6.65095 10.8499 6.63139 10.9591C6.57185 11.2921 6.39078 11.4366 6.11926 11.4866C5.84775 11.5366 5.47903 11.4477 5.15654 11.1289C4.74362 10.7208 3.23802 9.18534 2.5566 8.48963C2.25489 8.18151 1.8417 8.00883 1.41158 8.00883H1.02706C0.969085 8.00801 0.911527 8.01872 0.857728 8.04034C0.803929 8.06196 0.754964 8.09405 0.713677 8.13476C0.67239 8.17547 0.639606 8.22397 0.617229 8.27746C0.594852 8.33095 0.583328 8.38835 0.583328 8.44633C0.583328 8.50431 0.594852 8.56171 0.617229 8.6152C0.639606 8.66869 0.67239 8.71719 0.713677 8.7579C0.754964 8.79861 0.803929 8.8307 0.857728 8.85232C0.911527 8.87394 0.969085 8.88465 1.02706 8.88383H1.41158C1.60913 8.88383 1.79414 8.96155 1.93168 9.10201C2.61351 9.79813 4.10489 11.3196 4.5413 11.7509C5.04452 12.2485 5.6934 12.455 6.27763 12.3474C6.75135 12.2601 7.16624 11.9298 7.37366 11.4587C7.87258 11.4171 8.25593 11.1879 8.48735 10.9147C8.49323 10.915 8.49912 10.9152 8.50501 10.9152C8.50501 10.9152 9.82157 10.9382 10.5541 10.9152C11.0637 10.8994 11.5774 10.7265 12.0306 10.3291C12.2351 10.1499 12.4811 10.0499 12.7313 10.0499H12.9854C13.0434 10.0507 13.1009 10.04 13.1547 10.0184C13.2085 9.9968 13.2575 9.96471 13.2988 9.924C13.3401 9.88329 13.3728 9.83478 13.3952 9.7813C13.4176 9.72781 13.4291 9.67041 13.4291 9.61243C13.4291 9.55445 13.4176 9.49705 13.3952 9.44356C13.3728 9.39007 13.3401 9.34156 13.2988 9.30086C13.2575 9.26015 13.2085 9.22806 13.1547 9.20644C13.1009 9.18482 13.0434 9.17411 12.9854 9.17493H12.7313C12.2489 9.17493 11.8009 9.36726 11.4541 9.6711C11.1357 9.95035 10.8828 10.0298 10.5273 10.0408H10.5267C10.2879 10.0483 9.95518 10.0468 9.64205 10.0465C9.86523 9.86253 10.0654 9.59509 10.1889 9.23759C10.6944 9.12203 11.1228 8.83819 11.2832 8.39563C11.4813 7.8494 11.3272 7.18916 10.8412 6.69177C10.4729 6.31472 8.83769 4.49288 8.83769 4.49288C8.78032 4.42887 8.70538 4.38317 8.6222 4.36149C8.53903 4.33981 8.45131 4.34311 8.37 4.37097C8.37 4.37097 6.70378 4.92582 5.47612 4.92582C5.29434 4.92582 5.13622 4.90454 4.9976 4.87C4.823 4.8264 4.75704 4.71335 4.74182 4.56694C4.72669 4.42136 4.7746 4.29283 4.92127 4.2183L6.29073 3.64978C6.30836 3.64237 6.32549 3.6338 6.342 3.62415L7.83907 2.75883C8.16986 2.59417 8.52132 2.58177 8.83997 2.70927L10.8116 3.49768C11.0356 3.58769 11.2749 3.63319 11.5157 3.63326L12.9854 3.63383C13.0434 3.63465 13.1009 3.62394 13.1547 3.60232C13.2085 3.5807 13.2575 3.54861 13.2988 3.5079C13.3401 3.46719 13.3728 3.41869 13.3952 3.3652C13.4176 3.31171 13.4291 3.25431 13.4291 3.19633C13.4291 3.13835 13.4176 3.08095 13.3952 3.02746C13.3728 2.97398 13.3401 2.92547 13.2988 2.88476C13.2575 2.84405 13.2085 2.81196 13.1547 2.79034C13.1009 2.76872 13.0434 2.75801 12.9854 2.75883L11.5162 2.75826C11.3862 2.75826 11.2579 2.73409 11.138 2.68591L11.1368 2.68535L9.16524 1.89693C8.88976 1.7867 8.59581 1.73867 8.30278 1.75224Z"
                          fill="#27AE60"
                        />
                      </svg>

                      {wantAd.IntroCount}
                    </span>
                  </div>
                )}
                {wantAd.Title_Text ? (
                  <h2>{truncate(wantAd.Title_Text, 24)}</h2>
                ) : (
                  <h2 style={{ fontStyle: "italic" }}>Untitled</h2>
                )}
                <h6>{locationDisplayInListing(wantAd)}</h6>
              </div>
              <div
                className="side-nav-wrap"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic" variant="" align="end">
                    <img src={WantAdMoreIcon} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dpdown-menu-style" align={"end"}>
                    {status == "Published" && (
                      <Dropdown.Item
                        onClick={() => {
                          onShare(wantAd?.slug);
                        }}
                      >
                        Share
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>


            </div>

            <ul className="mt-2">
              {wantAd.Bedrooms ? (
                <li>
                  <div className="list-icns">
                    <img src={BedIcon} />
                  </div>
                  <span className="list-txt">
                    {wantAd.Bedrooms &&
                      wantAd.Bedrooms + (wantAd.Bedrooms == "any" ? "" : "+")}
                  </span>
                </li>
              ) : (
                ""
              )}
              {wantAd.Bathrooms ? (
                <li>
                  <div className="list-icns">
                    <img src={BathIcon} />
                  </div>
                  <span className="list-txt">
                    {wantAd.Bathrooms &&
                      wantAd.Bathrooms +
                      (wantAd.Bathrooms == "any" ? "" : "+")}
                  </span>
                </li>
              ) : (
                ""
              )}

              {sqFt &&
                PropertyTypeId &&
                PropertyTypeId != 11 &&
                PropertyTypeId != 6 ? (
                <li>
                  <div className="list-icns">
                    <img src={SqftIcon} />
                  </div>
                  <span className="list-txt">{sqFt} sqft</span>
                </li>
              ) : (
                ""
              )}
              {budget && PropertyTypeId ? (
                <li>
                  <div className="list-icns">
                    <img src={MoneyIcon} />
                  </div>
                  <span className="list-txt">
                    {budget}{" "}
                    {budget != BUDGET_NOMIN_NOMAX
                      ? wantAd?.Buy_or_Rent == 2 && "/month"
                      : ""}{" "}
                    {budget != BUDGET_NOMIN_NOMAX
                      ? wantAd?.Buy_or_Rent == 3 && "/night"
                      : ""}
                  </span>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      </a>
    </div>
  );
};

const ConsumerWantAdListings = (props) => {
  const navigate = useNavigate();

  const [pagecount, setPageCount] = useState(10);

  // To set the tab based on the value from URL mainly for link from Email
  const [searchParams] = useSearchParams();
  searchParams.get("Tab");
  const TabValueFromURL = searchParams.get("Tab");

  const location = useLocation();
  const state = location.state;

  //Added Logic to retrive the last visited tab -----V2 Change
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || "Published";
  const [status, setStatus] = useState(initialTab);
  const [loading, setLoading] = useState(false);
  const [currPage, setCurrPage] = useState(1); // storing current page number
  const [prevPage, setPrevPage] = useState(0); // storing prev page number
  const [wantAdList, setWantAdList] = useState([]); // storing list
  const [wasLastList, setWasLastList] = useState(false); // setting a flag to know the last list
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const [shareAdDetails, setShareAdDetails] = useState({});
  const loggedInUserId = getUserId();
  const agent = loggedInUser();

  const [wantAdData, setWantAdData] = useState(getLocalStorage(WANT_AD_KEY)); // to set the want-ad data

  const [deleteModalShow, setDeleteModalShow] = useState(false); //
  const [wantAdId, setWantAdId] = useState(0);
  const [deleteStatus, setDeleteStatus] = useState(false); //
  const [archiveModalShow, setArchiveModalShow] = useState(false); //
  const [archiveStatus, setArchiveStatus] = useState(false); //

  const [showShareModal, setShareModal] = useState(false);

  const [showNoResult, setShowNoResult] = useState(false);

  const [options, setOptions] = useState([
    { value: "createdon", label: "Recently " + status },
    { value: "Budget_mx", label: "Price" },
  ]);
  const [sortParam, setSortParam] = useState(options[0]);
  const [isSortParamChanged, setIsSortParamChanged] = useState(false);

  const [showCustomLinkPopuop, setShowCustomLinkPopup] = useState(false);
  const handleCustomLinkPopupOpen = () => {
    setShowCustomLinkPopup(true);
  };
  const handleCustomLinkPopupClose = () => {
    setShowCustomLinkPopup(false);
  };

  const [linkToShare, setLinkToShare] = useState("");

  // to list my want-ad
  useEffect(() => {
    if (deleteStatus == true || archiveStatus == true || isSortParamChanged) {
      setCurrPage(1);
      setPrevPage(0);
      setWantAdList([]);
      setWasLastList(false);
      setDeleteStatus(false);
      setArchiveStatus(false);
      setIsSortParamChanged(false);
    }

    if (!wasLastList && prevPage !== currPage) {
      const data = {
        status: status,
        sortBy: sortParam?.value,
        page: currPage,
        limit: pagecount,
      };
      fetchMyWantAd(data);
    }
  }, [
    currPage,
    wasLastList,
    status,
    sortParam?.value,
    isSortParamChanged == true,
    deleteStatus == true,
    archiveStatus == true,
  ]);

  const fetchMyWantAd = async (query) => {
    setLoading(true);
    try {
      const response = await getMyWantAds(query);
      const responseResult = _.get(response, "result", null);

      if (response.errorCode === 0 && responseResult.length > 0) {
        setWantAdList((prevList) => [...prevList, ...responseResult]);
        setPrevPage(currPage);
        setWasLastList(false);
      } else if (responseResult && responseResult.length === 0) {
        setWasLastList(true);
        setShowNoResult(true);
      }
    } catch (err) {
      console.log("Error", err);
    } finally {
      setLoading(false);
    }
  };

  /**
   * To handle scroll for pagination
   */
  const handleScroll = () => {
    const bottom =
      Math.ceil(window.innerHeight + window.scrollY) >=
      document.documentElement.scrollHeight;

    if (bottom) {
      setTimeout(function () {
        setCurrPage((prevState) => prevState + 1);
      }, 400);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  //Added logic to retrive the previous visited Tab
  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);

    if (currentParams.get("tab") !== status) {
      currentParams.set("tab", status);
      navigate(`?${currentParams.toString()}`, { replace: true });
    }
  }, [status, navigate]);

  useEffect(() => {
    setOptions([
      { value: "createdon", label: "Recently " + status },
      { value: "Budget_mx", label: "Price" },
    ]);
    setSortParam({ value: "createdon", label: "Recently " + status });
  }, [status]);

  useEffect(() => {
    setLocalStorage(WANT_AD_KEY, wantAdData);
  }, [wantAdData]);

  const handleSortParam = (selectedParam) => {
    setIsSortParamChanged(true);
    setSortParam(selectedParam);
  };

  /**
   * want ad  delete button click action
   * @param Id string
   */
  const onWantAdDelete = (slug) => {
    setDeleteModalShow(true);
    setWantAdId(slug);
  };

  /**
   * To handle the want-ad delete
   */
  const handleDeleteWantAd = async () => {
    if (wantAdId) {
      setShowNoResult(true);
      await deleteWantAd(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);

          if (response.errorCode === 0 && responseResult) {
            toast.success("Your want-listing has been deleted.");
            setDeleteModalShow(false);
            setDeleteStatus(!deleteStatus);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  /**
   * want ad  archive button click action
   * @param Id string
   */
  const onWantAdArchived = (id) => {
    setArchiveModalShow(true);
    setWantAdId(id);
  };

  /**
   * To handle the want-ad archive
   */
  const handleArchiveWantAd = async () => {
    if (wantAdId) {
      setShowNoResult(true);
      await archiveWantAd(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            toast.success("Your want-listing has been paused.");
            setArchiveModalShow(false);
            setArchiveStatus(!archiveStatus);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  /**
   * To handle the want-ad un archive
   */
  const handleUnArchiveWantAd = async (wantAd) => {
    // GTCH-853: markets served by the BLS keep their archived want-listings
    // archived.
    if (isMarketRestrictedWantAd(wantAd)) {
      toast.error(
        "Want-Listings in this market are managed through The Buyer Listing Service® and can't be re-activated here."
      );
      return;
    }
    if (wantAd?.Want_ad_Id) {
      if (
        (wantAd?.Buy_or_Rent == 2 && wantAd?.Move_in_TimeLine == 11) ||
        wantAd?.Buy_or_Rent == 3
      ) {
        getWantAdDetails(wantAd?.Want_ad_Id, { isFromUnPause: true });
      } else {
        setShowNoResult(true);
        await unArchiveWantAd(wantAd?.Want_ad_Id)
          .then((response) => {
            if (response.errorCode == 0) {
              toast.success(
                "Your paused want-listing has been made public again.",
              );
              setArchiveStatus(!archiveStatus);
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };

  const viewIntroductions = (wantAdId, slug, status) => {
    setLocalStorage(WANT_AD_KEY, { wantAdId: wantAdId, introId: 1 });
    navigate(`${pageURLs.wantAdDetails}/${slug}`);
  };

  const renderTooltip = (PropertyTypeId, subPropertyTypeId, Buy_or_Rent) => (
    <Tooltip
      id="button-tooltip"
      placement="bottom-start"
      className="custom-tooltip"
      {...props}
    >
      {subPropertyTypeId &&
        subPropertyTypeId.length > 0 &&
        getCombinedText(subPropertyTypeId)}
    </Tooltip>
  );

  /**
   * On edit button click
   * @param {*} wantAdId
   */
  const onEdit = (slug) => {
    getWantAdDetails(slug, { isEdit: true });
  };

  const getWantAdDetailsForShare = async (slug) => {
    if (slug) {
      await getWantAdById(slug, loggedInUserId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setShareAdDetails(responseResult);
            setShareModal(true);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const onShare = (slug) => {
    getWantAdDetailsForShare(slug);
  };

  /**
   * get want-ad details for edit
   * @param {*} wantAdId
   */

  const { redirectToBLSEnv } = useMLSAgentAtGitchaRedirect();

  const getWantAdDetails = async (wantAdId, isFromData) => {
    if (wantAdId) {
      await getWantAdById(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            redirectToBLSEnv({
              path: `${pageURLs.agentCreatewantad}?wantAdId=${wantAdId}`, onGitchaEnvFallback: null,
            });
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      navigate(pageURLs.agentCreatewantad);
    }
  };

  const { shouldRestrictAgent } = useAgentGitchaRestrictions()

  return (
    <>
      <CustomLinkModal
        show={showCustomLinkPopuop}
        onHide={handleCustomLinkPopupClose}
        linkToShare={linkToShare}
      />

      <PageWrapper>
        <div className="row">
          <div className="col-md-12">
            <div className="my-want-ad-wrap">
              <div className="top-sec mb-24 md-mt-24">
                <div className="row">
                  <div className="col">
                    <h2>My {shouldRestrictAgent ? 'Syndicated' : ''} Want-Listings</h2>
                  </div>
                  <div
                    col="12"
                    className="d-flex d-sm-block flex-column col-sm-auto"
                  >
                    <div className="d-flex select-wrap">
                      <Form.Label className="">Sort By:</Form.Label>
                      <SelectDropDown
                        id="multi3"
                        name="colors3"
                        options={options}
                        className="basic-single my-inventory-select mb-0 ms-3"
                        classNamePrefix="select"
                        placeholder="Select"
                        value={sortParam}
                        onChange={handleSortParam}
                        styles={{
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform:
                              state.selectProps.menuIsOpen && "rotate(180deg)",
                          }),
                        }}
                        errorClass="error-msg error-msg-height"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-wrap tab-wrap-fix position-relative">
                {wantAdList &&
                  wantAdList.length > 2 &&
                  status == "Published" && (
                    <div className="post-btn-wrap">
                      <button
                        className="btn btn-tertiary d-flex align-items-center"
                        onClick={() =>
                          redirectToBLSEnv({
                            path: `${pageURLs.agentCreatewantad}`, onGitchaEnvFallback: null,
                          })
                        }
                      >
                        Post{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                        >
                          <g transform="translate(-2 -2)">
                            <path
                              d="M2,8a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,0,1H2.5A.5.5,0,0,1,2,8Z"
                              fill="#000"
                              fillRule="evenodd"
                            />
                            <path
                              d="M8,2a.5.5,0,0,1,.5.5v11a.5.5,0,0,1-1,0V2.5A.5.5,0,0,1,8,2Z"
                              fill="#000"
                              fillRule="evenodd"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>
                  )}
                <Tabs
                  id="controlled-tab-example"
                  className="mb-3"
                  activeKey={status}
                  onSelect={(k) => {
                    setWantAdList([]);
                    setCurrPage(1);
                    setStatus(k);
                    setPrevPage(0);
                    setWasLastList(false);
                  }}
                >
                  <Tab eventKey="Published" title="Published">
                    <div className="row want-listing-row">
                      {loading && (
                        <>
                          <Loader />
                        </>
                      )}
                      {wantAdList !== null && wantAdList?.length > 0 ? (
                        wantAdList?.map((wantAd, i) => {
                          return (
                            <WantAdCard
                              key={i}
                              wantAd={wantAd}
                              status={status}
                              viewIntroductions={viewIntroductions}
                              onEdit={onEdit}
                              onShare={onShare}
                              agent={agent}
                              setLinkToShare={setLinkToShare}
                              handleCustomLinkPopupOpen={handleCustomLinkPopupOpen}
                              renderTooltip={renderTooltip}
                            />
                          );
                        })
                      ) : (
                        <></>
                      )}

                      {wantAdList && wantAdList.length <= 2 && (
                        <div className="col-md-4">
                          <button
                            className="btn create-wantad-btn"
                            onClick={() =>
                              redirectToBLSEnv({
                                path: `${pageURLs.agentCreatewantad}`, onGitchaEnvFallback: null,
                              })
                            }
                          >
                            <span>
                              <svg
                                width="15"
                                height="14"
                                viewBox="0 0 15 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M1.91669 7C1.91669 6.75838 2.11256 6.5625 2.35419 6.5625H11.9792C12.2208 6.5625 12.4167 6.75838 12.4167 7C12.4167 7.24162 12.2208 7.4375 11.9792 7.4375H2.35419C2.11256 7.4375 1.91669 7.24162 1.91669 7Z"
                                  fill="#022964"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.16669 1.75C7.40831 1.75 7.60419 1.94588 7.60419 2.1875V11.8125C7.60419 12.0541 7.40831 12.25 7.16669 12.25C6.92506 12.25 6.72919 12.0541 6.72919 11.8125V2.1875C6.72919 1.94588 6.92506 1.75 7.16669 1.75Z"
                                  fill="#022964"
                                />
                              </svg>
                            </span>{" "}
                            Create want-listing
                          </button>
                        </div>
                      )}
                    </div>
                  </Tab>

                  <Tab eventKey="Paused" title="Paused">
                    <div className="row  want-listing-row">
                      {loading && (
                        <>
                          <Loader />
                        </>
                      )}
                      {wantAdList !== null && wantAdList?.length > 0 ? (
                        wantAdList?.map((wantAd, i) => {
                          return (
                            <WantAdCard
                              key={i}
                              wantAd={wantAd}
                              status={status}
                              viewIntroductions={viewIntroductions}
                              onEdit={onEdit}
                              onShare={onShare}
                              agent={agent}
                              setLinkToShare={setLinkToShare}
                              handleCustomLinkPopupOpen={handleCustomLinkPopupOpen}
                              renderTooltip={renderTooltip}
                            />
                          );
                        })
                      ) : (
                        <></>
                      )}

                      {wantAdList && wantAdList.length <= 2 && (
                        <div className="col-md-4">
                          <button
                            className="btn create-wantad-btn"
                            onClick={() =>
                              redirectToBLSEnv({
                                path: `${pageURLs.agentCreatewantad}`, onGitchaEnvFallback: null,
                              })
                            }
                          >
                            <span>
                              <svg
                                width="15"
                                height="14"
                                viewBox="0 0 15 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M1.91669 7C1.91669 6.75838 2.11256 6.5625 2.35419 6.5625H11.9792C12.2208 6.5625 12.4167 6.75838 12.4167 7C12.4167 7.24162 12.2208 7.4375 11.9792 7.4375H2.35419C2.11256 7.4375 1.91669 7.24162 1.91669 7Z"
                                  fill="#022964"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.16669 1.75C7.40831 1.75 7.60419 1.94588 7.60419 2.1875V11.8125C7.60419 12.0541 7.40831 12.25 7.16669 12.25C6.92506 12.25 6.72919 12.0541 6.72919 11.8125V2.1875C6.72919 1.94588 6.92506 1.75 7.16669 1.75Z"
                                  fill="#022964"
                                />
                              </svg>
                            </span>{" "}
                            Create want-listing
                          </button>
                        </div>
                      )}
                    </div>
                  </Tab>

                  <Tab eventKey="Draft" title="Drafts">
                    <div className="row  want-listing-row">
                      {loading && (
                        <>
                          <Loader />
                        </>
                      )}
                      {showNoResult ||
                        (wantAdList !== null && wantAdList?.length > 0)
                        ? wantAdList?.map((wantAd, i) => {
                          return (
                            <WantAdCard
                              key={i}
                              wantAd={wantAd}
                              status={status}
                              viewIntroductions={viewIntroductions}
                              onEdit={onEdit}
                              onShare={onShare}
                              agent={agent}
                              setLinkToShare={setLinkToShare}
                              handleCustomLinkPopupOpen={handleCustomLinkPopupOpen}
                              renderTooltip={renderTooltip}
                            />
                          );
                        })
                        : !showNoResult && (
                          <div className="no-result-wrap mw-435">
                            <h3>No results found</h3>
                          </div>
                        )}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>

      {/*  Delete confirmation Modal */}
      <DeleteModal
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        title={"Are you sure you want to permanently delete your want-listing?"}
        message={
          "Deleting this listing will stop any further introductions from being sent to you."
        }
        buttonText={" Delete Want-Listing"}
        handleConfirm={() => handleDeleteWantAd()}
      />

      {/*  ArchiveModal confirmation Modal */}
      <ArchiveModal
        show={archiveModalShow}
        onHide={() => setArchiveModalShow(false)}
        handleConfirm={() => handleArchiveWantAd()}
      />
      {showShareModal && (
        <ShareYourAdModal
          show={showShareModal}
          onHide={() => setShareModal(false)}
          isWantAdCreated={false}
          adDetails={shareAdDetails}
          AdType={_.get(shareAdDetails, "adType", "") === "BUY" ? 1 : 2}
          isAdTypeIsLand={_.get(shareAdDetails, "prprtyType", "") === 6}
          adTypeBasedOnProperty={
            _.get(shareAdDetails, "prprtyType", "") === 6
              ? LOT_LAND
              : _.get(shareAdDetails, "adType", "")
          }
        />
      )}
    </>
  );
};

export default ConsumerWantAdListings;
